import script from "./VInputMoney.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputMoney.vue?vue&type=script&setup=true&lang=ts"

import "./VInputMoney.vue?vue&type=style&index=0&id=c424dfe0&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c424dfe0"]])

export default __exports__